/**
 * Copy de UI MedDream: labels cortos + descripciones autoexplicativas.
 * No incluye connectionSum ni sessionIds (no se muestran).
 */

export interface MeddreamLabelCopy {
  label: string;
  description: string;
}

export const MEDDREAM_LABELS = {
  peakConnections: {
    label: "Pico de conexiones",
    description: "Máximo de conexiones concurrentes vistas en la hora",
  },
  minConnections: {
    label: "Mínimo de conexiones",
    description: "Mínimo concurrente en las mediciones de la hora",
  },
  avgConnections: {
    label: "Carga típica",
    description: "Promedio de las mediciones UserConnection de la hora",
  },
  /** KPI del período: suma de uniqueSessionsCount */
  sessionActivity: {
    label: "Actividad de sesiones",
    description:
      "Suma de sesiones-hora del rango; no son usuarios únicos del período",
  },
  /** Valor de una sola hora */
  sessionsInHour: {
    label: "Sesiones activas (hora)",
    description:
      "IDs de sesión distintos con actividad en esa hora; no son logins nuevos",
  },
  restarts: {
    label: "Reinicios del servicio",
    description: "Eventos SystemInfo (arranque/reinicio) en la hora",
  },
  samples: {
    label: "Mediciones del log",
    description:
      "Fotos UserConnection en la hora (~1/min ⇒ ~60/h). No son usuarios",
  },
  updatedAt: {
    label: "Última actualización",
    description: "Cuándo el cron escribió el documento",
  },
  coverage: {
    label: "Cobertura de horas",
    description: "Horas con documento / horas esperadas del rango",
  },
  /** Header: avg / max juntos */
  currentLoad: {
    label: "Carga típica / pico",
    description:
      "Promedio y máximo de conexiones concurrentes en la hora UTC en curso",
  },
  rangeMinMax: {
    label: "Rango min–max",
    description: "Volatilidad de conexiones concurrentes en la hora",
  },
} as const satisfies Record<string, MeddreamLabelCopy>;

export type MeddreamLabelKey = keyof typeof MEDDREAM_LABELS;

export function meddreamLabel(key: MeddreamLabelKey): string {
  return MEDDREAM_LABELS[key].label;
}

export function meddreamDescription(key: MeddreamLabelKey): string {
  return MEDDREAM_LABELS[key].description;
}
